
export class TargetObjectAttributeFilterOptions {
    targetObjectAttributeIds: Array<number>;
    targetObjectIds: Array<number>;
    dataOwnerIds: Array<number>;
}
